module.exports = __webpack_public_path__ + "img/jamaica.6b817245.svg";